"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyCreator = void 0;
var createArrayHandler_1 = require("./createArrayHandler");
var createSubjectHandler_1 = require("./createSubjectHandler");
/**
 * This file keeps track of the target objects used in the proxies.
 * The reason is so that JSON.stringify does not recurse inifinitely
 * when it encounters a circular object.
 */
var ProxyCreator = /** @class */ (function () {
    function ProxyCreator() {
        this.subjectMap = new Map();
        this.arrayMap = new Map();
    }
    ProxyCreator.prototype.createSubjectProxy = function (node, dataset, contextUtil) {
        if (!this.subjectMap.has(node.value)) {
            var proxy = new Proxy({ "@id": node }, (0, createSubjectHandler_1.createSubjectHander)(dataset, contextUtil, this));
            this.subjectMap.set(node.value, proxy);
        }
        return this.subjectMap.get(node.value);
    };
    ProxyCreator.prototype.getArrayKey = function () {
        var quadMatch = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            quadMatch[_i] = arguments[_i];
        }
        return "".concat(quadMatch[0].value, "|").concat(quadMatch[1].value);
    };
    ProxyCreator.prototype.createArrayProxy = function (quadMatch, dataset, contextUtil) {
        var key = this.getArrayKey.apply(this, __spreadArray([], __read(quadMatch), false));
        if (!this.arrayMap.has(key)) {
            var proxy = new Proxy([quadMatch, []], (0, createArrayHandler_1.createArrayHandler)(dataset, contextUtil, this));
            this.arrayMap.set(key, proxy);
        }
        return this.arrayMap.get(key);
    };
    return ProxyCreator;
}());
exports.ProxyCreator = ProxyCreator;
